import { ca } from '@cian/analytics';

export function openQuestion() {
  ca('eventSite', {
    name: 'oldevent',
    action: 'click',
    category: 'HowToSellApartmentLanding',
    label: 'question',
  });
}

export function openPrice() {
  ca('eventSite', {
    name: 'oldevent',
    action: 'click',
    category: 'HowToSellApartmentLanding',
    label: 'price',
  });
}

export function openAskProffesional() {
  ca('eventSite', {
    name: 'oldevent',
    action: 'click',
    category: 'HowToSellApartmentLanding',
    label: 'askProfessionals',
  });
}

export function openArticle(articleName: string, articleLink: string) {
  ca('eventSite', {
    name: 'oldevent',
    action: 'click',
    category: 'HowToSellApartmentLanding',
    label: 'article',
    page: {
      pageType: 'HowToSellAnApartment',
      extra: {
        article: articleName,
        article_link: articleLink,
      },
    },
  });
}
